export enum TravelRequestTime {
  Morning = "Morning",
  Day = "Day",
  Noon = "Noon",
  Evening = "Evening"
}
